export default __webpack_public_path__ + "static/media/landing.30610272.png";